import { render } from "./S187312.vue?vue&type=template&id=1ddb41cf"
const script = {}
script.render = render

export default script